// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3vSHo","content":"styles_content__yHruB","selectAll":"styles_selectAll__3pJek"};